import { getConstants } from "@utilifiles/methods/storage/storage";
import instance from "@services/services";
import { ResponseType } from "../../../Types/ServicesType/servicesType";
import {
  MasterDataType,
  MasterTableDataType,
  SaveResponseType,
  SearchParamsType,
} from "./types";
import api from "@services/apiList";
const { clinicId } = getConstants();
const {MastersApi} = api
export const getMastersTableData = async (
  payload: SearchParamsType
): Promise<ResponseType<MasterTableDataType[]>> => {
  const result = await instance.post(`${MastersApi.getCategory}`, {
    clinicId,
    ...payload,
  });
  return result.data;
};

export const saveMasterData = async (
  params: MasterDataType
): Promise<ResponseType<SaveResponseType>> => {
  const result = await instance.post(`${MastersApi.saveCategory}`, params);
  return result.data;
};

export const getSecimen = async (): Promise<
  ResponseType<{
    specimenName: string;
    specimenId: number;
    clinicId: number;
  }[]>
> => {
  const result = await instance.post(`${MastersApi.getSpecimen}`, { clinicId });
  return result.data;
};
